import { PageContextProps } from 'application/contexts/PageContext';
import jsonpath from 'jsonpath';
import { queryCDA } from './queryCDA';

const getFilters = async (module, pageContext) => {
	try {
		const data = await queryCDA({
			pageContext,
			url: 'umbraco/delivery/api/v2/content',
			urlParams: {
				fetch: `children:${module.content?.properties.folder[0].id}`,
				fields: 'properties[hideSiblingMenu,highlighted,navigationDescription,navigationTitle,pageTransportLinksHide,umbracoNaviHide]',
				sort: 'sortOrder:asc',
				take: '100',
			},
			requestType: 'pageContent',
		});
		return data;
	} catch (error) {
		throw `ERROR: getFilters - module id: ${module.content.id} - ` + error;
	}
};

export const getFiltersContent = async (content: Content.Filters, pageContext: Partial<PageContextProps>) => {
	if (!content?.items) return null;

	try {
		const filterTagsModules = jsonpath.query(content, '$..items[?(@.content.contentType=="tagFolderPicker")]');
		if (filterTagsModules.length > 0) {
			await Promise.all(
				filterTagsModules.map(async (module) => {
					const filters = await getFilters(module, pageContext);

					jsonpath.value(
						content,
						`$..items[?(@.content.id=="${module.content.id}")].content.properties.folder[0].properties`,
						filters.items,
					);
				}),
			);
		}

		const filterTypesModules = jsonpath.query(content, '$..items[?(@.content.contentType=="typesFolderPicker")]');
		if (filterTypesModules.length > 0) {
			await Promise.all(
				filterTypesModules.map(async (module) => {
					const filters = await getFilters(module, pageContext);

					jsonpath.value(
						content,
						`$..items[?(@.content.id=="${module.content.id}")].content.properties.folder[0].properties`,
						filters.items,
					);
				}),
			);
		}

		return content;
	} catch (error) {
		console.log('ERROR in getFiltersContent - ', error);
		return content;
	}
};
